import { CheckBox } from '@components/ui/checkbox';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';
import { IoChevronDown } from 'react-icons/io5';
const priceFilterItems = [
  {
    id: '1',
    name: 'Under 3000 ALL',
    slug: '0-3000',
  },
  {
    id: '2',
    name: '3000 ALL to 6000 ALL',
    slug: '3000-6000',
  },
  {
    id: '3',
    name: '6000 ALL to 10 000 ALL',
    slug: '6000-10000',
  },
  {
    id: '4',
    name: 'Over 10 000 ALL',
    slug: '10000+',
  },
  // {
  //   id: '5',
  //   name: '$200 to $300',
  //   slug: '200-300',
  // },
  // {
  //   id: '6',
  //   name: '$300 to $500',
  //   slug: '300-500',
  // },
  // {
  //   id: '7',
  //   name: '$500 to $1000',
  //   slug: '500-1000',
  // },
  // {
  //   id: '8',
  //   name: 'Over $1000',
  //   slug: '1000+',
  // },
];

export const PriceFilter = () => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const { pathname, query } = router;
  const [isOpen, setIsOpen] = useState(true);
  const selectedPrices = query?.price ? (query.price as string).split(',') : [];
  const [formState, setFormState] = React.useState<string[]>(selectedPrices);
  React.useEffect(() => {
    setFormState(selectedPrices);
  }, [query?.price]);
  function handleItemClick(e: React.FormEvent<HTMLInputElement>): void {
    const { value } = e.currentTarget;
    let currentFormState = formState.includes(value)
      ? formState.filter((i) => i !== value)
      : [...formState, value];
    // setFormState(currentFormState);
    const { price, ...restQuery } = query;
    router.push(
      {
        pathname,
        query: {
          ...restQuery,
          ...(!!currentFormState.length
            ? { price: currentFormState.join(',') }
            : {}),
        },
      },
      undefined,
      { scroll: false },
    );
  }
  const items = priceFilterItems;

  return (
    <div className="block mb-2">
      <h3
        className="text-[#333333] text-sm md:text-lg mb-5 flex justify-between items-center cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{t('text-price')}</span>
        <IoChevronDown
          className={`transition-transform duration-200 text-[#9D9D9D] ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </h3>
      {isOpen && (
        <div className="mt-2 flex flex-col space-y">
          {items?.map((item: any) => (
            <CheckBox
              key={item.id}
              label={item.name}
              name={item.name.toLowerCase()}
              checked={formState.includes(item.slug)}
              value={item.slug}
              onChange={handleItemClick}
              className="text-[#333333]"
              hideTick={true}
            />
          ))}
        </div>
      )}
    </div>
  );
};
